export default __webpack_public_path__ + "static/media/arrow_on.e909e914.png";